import { connect } from 'react-redux';

import {
  filterPushValue,
  filterPopValue,
  filterInit,
  filterResetValues,
  filterFetchTagsData
} from '../../../redux/actions/filter';

import TagFilter from './tagFilter';

const mapDispatchToProps = dispatch => ({
  updateTagValue: (value, checked, fetchDynamically) => {
    if (checked) {
      dispatch(filterPushValue(value, 'filteredTags'));
    } else {
      dispatch(filterPopValue(value, 'filteredTags'));
    }
    if (fetchDynamically) {
      dispatch(filterFetchTagsData());
    }
  },
  resetFilteredTags: fetchDynamically => {
    dispatch(filterResetValues('filteredTags'));
    if (fetchDynamically) {
      dispatch(filterFetchTagsData());
    }
  },
  initFilteredTags: value => {
    dispatch(filterInit(value, 'filteredTags'));
  }
});

const mapStateToProps = ({ filter, app }) => ({
  slug: app.pageData.slug,
  tags: app.pageData.allTypeTags,
  isLoading: filter.isLoading,
  filteredTags: filter.filteredTags
});

export default connect(mapStateToProps, mapDispatchToProps)(TagFilter);
